import sectionIcon from '../assets/icons/section.png';
import column1Icon from '../assets/icons/1column.png';
import column2Icon from '../assets/icons/2column.png';
import column3Icon from '../assets/icons/3column.png';
import linkBoxIcon from '../assets/icons/linkBox.png';
import linkIcon from '../assets/icons/link.png';
import dividerIcon from '../assets/icons/divider.png';
import headingIcon from '../assets/icons/heading.png';
import textIcon from '../assets/icons/text.png';
import imageIcon from '../assets/icons/image.png';
import videoIcon from '../assets/icons/video.png';
import formIcon from '../assets/icons/form.png';
import navbarIcon from '../assets/icons/navbar.png';
import accordionIcon from '../assets/icons/accordion.png';

export const defaultBlocks = [
  {
    id: 'section',
    label: 'Section',
    category: 'Structure',
    media: `<img src="${sectionIcon}" alt="Section" style="width: 100%; height: 100%; object-fit: contain;" />`,
    content: { type: 'section' },
    select: true,
  },
  {
    id: 'column1',
    label: '1 Column',
    category: 'Structure',
    media: `<img src="${column1Icon}" alt="1 Column" style="width: 100%; height: 100%; object-fit: contain;" />`,
    content: { type: 'gridRow', components: [{ type: 'gridColumn' }] },
    select: true,
  },
  {
    id: 'column2',
    label: '2 Columns',
    category: 'Structure',
    media: `<img src="${column2Icon}" alt="2 Columns" style="width: 100%; height: 100%; object-fit: contain;" />`,
    content: { type: 'gridRow', components: [{ type: 'gridColumn' }, { type: 'gridColumn' }] },
    select: true,
  },
  {
    id: 'column3',
    label: '3 Columns',
    category: 'Structure',
    media: `<img src="${column3Icon}" alt="3 Columns" style="width: 100%; height: 100%; object-fit: contain;" />`,
    content: { type: 'gridRow', components: [{ type: 'gridColumn' }, { type: 'gridColumn' }, { type: 'gridColumn' }] },
    select: true,
  },
  {
    id: 'linkBox',
    label: 'Link Box',
    category: 'Basic',
    content: { type: 'linkBox' },
    media: `<img src="${linkBoxIcon}" alt="Link Box" style="width: 100%; height: 100%; object-fit: contain;" />`,
    select: true,
  },
  {
    id: 'link',
    label: 'Link',
    category: 'Basic',
    content: { type: 'link', content: 'Link', style: { padding: '10px', color: '#d983a6' } },
    media: `<img src="${linkIcon}" alt="Link" style="width: 100%; height: 100%; object-fit: contain;" />`,
    select: true,
  },
  {
    id: 'divider',
    label: 'Divider',
    category: 'Basic',
    content: { type: 'divider' },
    media: `<img src="${dividerIcon}" alt="Divider" style="width: 100%; height: 100%; object-fit: contain;" />`,
    select: true,
  },
  {
    id: 'heading',
    label: 'Heading',
    category: 'Typography',
    content: { type: 'heading', components: 'Insert your text here' },
    media: `<img src="${headingIcon}" alt="Heading" style="width: 100%; height: 100%; object-fit: contain;" />`,
    select: true,
  },
  {
    id: 'text',
    label: 'Text',
    category: 'Typography',
    content: { type: 'text', content: 'Insert your text here', style: { padding: '10px' } },
    media: `<img src="${textIcon}" alt="Text" style="width: 100%; height: 100%; object-fit: contain;" />`,
    select: true,
  },
  {
    id: 'image',
    label: 'Image',
    category: 'Media',
    content: { type: 'image', style: { color: 'black' } },
    media: `<img src="${imageIcon}" alt="Image" style="width: 100%; height: 100%; object-fit: contain;" />`,
    select: true,
  },
  {
    id: 'custom-video',
    label: 'Video',
    category: 'Media',
    content: { type: 'custom-video' },
    media: `<img src="${videoIcon}" alt="Video" style="width: 100%; height: 100%; object-fit: contain;" />`,
    select: true,
  },
  {
    id: 'form-picker',
    label: 'Form picker',
    category: 'forms',
    media: `<img src="${formIcon}" alt="Form picker" style="width: 100%; height: 100%; object-fit: contain;" />`,
    content: { type: 'form-picker-placeholder' },
    select: true,
    activate: true,
  },
  {
    id: 'navbar',
    label: 'Navbar',
    category: 'Advanced',
    content: { type: 'navbar' },
    media: `<img src="${navbarIcon}" alt="Navbar" style="width: 100%; height: 100%; object-fit: contain;" />`,
    select: true,
  },
  {
    id: 'accordion',
    label: 'Accordion',
    category: 'Advanced',
    content: { type: 'accordion' },
    media: `<img src="${accordionIcon}" alt="Accordion" style="width: 100%; height: 100%; object-fit: contain;" />`,
    select: true,
  },
  {
    id: 'accordion-group',
    label: 'Accordion Group',
    category: 'Advanced',
    content: { type: 'accordion-group' },
    media: `<img src="${accordionIcon}" alt="Accordion Group" style="width: 100%; height: 100%; object-fit: contain;" />`,
    select: true,
  },
];
